import { SkudCommandEndpoint } from '@/views/skud/shared/endpoint_services/skud-command-endpoint-service'
import { PointCommandType, enumText } from '@/views/skud/shared/models/enums'

export class SkudCommandService {
  constructor () {
    this.endpoint = new SkudCommandEndpoint()
  }

  // -> {ok:true, data:{command_id}} | {ok:false, error}
  async issueCommand (placeId, body) {
    return this.endpoint.issueCommand(placeId, body)
  }

  // Числовой тип команды -> русская подпись.
  typeText (type) {
    return enumText(PointCommandType, type)
  }
}
